export type InfoType = "Error" | "Info" | "Warning" | "Success" |null

export interface InfoAction {
    text: string;
    btn: () => void;
    disabled?: boolean;
    bgColor?: string;
    textColor?: string;
}
export  interface InfoPros{
    close?: () =>void
    title?: string
    show: boolean,
    description?: string
    infoType?: InfoType
    actions?: InfoAction[]
}

export interface FilterOption {
    fromDate?: Date|null;
    toDate?: Date|null;
    vesselRegistrationNumber?: string;
    skip?: number;
    take?: number;
}


export class CustomError extends Error {
    title?: string 
    name: string = 'CustomError'
    constructor(message: string, title?: string) {
        super(message);
        this.title = title
        this.name = 'CustomError';
    }

}

export  enum IconButtonActionType {
    Read = "read",
    Update = "update",
    Delete = "delete",
    Create = "create",
    Other = "other",
}